/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Csjensblank_Hsrm15Inputs */

const en__field_enum_csjensblank_hsrm15 = /** @type {(inputs: _Field_Enum_Csjensblank_Hsrm15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochschule RheinMain`)
};

const de__field_enum_csjensblank_hsrm15 = /** @type {(inputs: _Field_Enum_Csjensblank_Hsrm15Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochschule RheinMain`)
};

/**
* | output |
* | --- |
* | "Hochschule RheinMain" |
*
* @param {_Field_Enum_Csjensblank_Hsrm15Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_csjensblank_hsrm15 = /** @type {((inputs?: _Field_Enum_Csjensblank_Hsrm15Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Csjensblank_Hsrm15Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_csjensblank_hsrm15(inputs)
	return de__field_enum_csjensblank_hsrm15(inputs)
});
export { _field_enum_csjensblank_hsrm15 as "_field_enum_CSJENSBLANK_HSRM" }